import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const AttachmentLabel = styled.label`
  position: relative;
  width: 100%;
  float: left;
  color: #333;
  text-align: left;
  transition: 0.15s ease-in-out;
  margin-bottom: 0;

  svg,
  i {
    margin-right: 15px;
    font-size: 1.2em;
    position: relative;
    top: 1px;
  }

  .fa-plus-circle {
    position: absolute;
    top: 25px;
    left: 45px;
  }

  &:hover {
    cursor: pointer;
    color: #79D9D9;
  }
`;

export const Attachment = styled.input``;

export const AttachmentButton = styled.span``;

export const AttachmentFilename = styled.div`
  max-width: 300px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;

  ${mediaMaxWidth.phone`
    max-width: 250px;
  `}
`;

export const AttachmentRemoveButon = styled.div`
  z-index: 2;
  color: #79D9D9;
  font-size: 0.95em;
  font-weight: 500;
  text-align: center;
  visibility: hidden;
  opacity: 0;
  cursor: pointer;
  transition: visibility 0s, opacity 0.5s linear;

  &.show {
    visibility: visible;
    opacity: 1;
  }

  &:hover {
    color: #402680;
  }
`;
